<template>
  <div class="product-tag-icons flex items-end">
    <div
      v-for="(key, index) in tagMap"
      :key="key"
      :style="{ 'z-index': 10 - index }"
      class="relative cursor-pointer"
    >
      <div class="relative flex items-center flex-col-reverse text-gray-600 py-1 px-2 w-6 h-6">
        <button
          class="peer flex-center w-7 h-7 z-10 hover:text-white"
          :aria-label="`tag ${key}`"
          data-gtm-action="show tag"
        >
          <svg-icon
            :name="`filter-${key}`"
            class="h-4 w-4"
          />
        </button>
        <div class="product-tag-label hidden absolute top-0 bottom-0 z-0 py-0.5 text-white text-sm capitalize whitespace-nowrap pointer-events-none peer-hover:bg-gray-800/90 peer-hover:block">
          <div>
            {{ $t(`bundler.filters.${key}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BUNDLE_FILTERS } from '@/services/constants'
export interface Props {
  tags: string[]
}
const props = defineProps<Props>()
const tagMap = BUNDLE_FILTERS.filter((filter) => props.tags.includes(filter))
</script>
